import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserBoxService {
  constructor(private http:HttpClient) { }

  profileUpdate(data:any){
    return this.http.post(environment.apiUrl + 'admin/update' ,data)
  }

}
